import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import './ListDropdown.module.css';
import Link from '../atoms/Link/Link';

const ListDropdown = ({
  title,
  children,
  dropdownType = 'original',
  styling = null
}) => {
  // if dropdownType is 'original' or 'textDropdown' then children is a normal javascript array, Otherwise children are react components.
  const [open, setOpen] = useState(false);
  const toggleDropdown = useRef();
  const dropdownListRef = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const handleClick = e => {
    const newOpen = !toggleDropdown.current.contains(e.target)
      ? false
      : dropdownListRef.current && dropdownListRef.current.contains(e.target)
      ? 'ignore'
      : open => !open;
    if (newOpen === 'ignore') return;
    setOpen(newOpen);
  };
  const isOriginal = dropdownType === 'original';
  const isTextDropdown = dropdownType === 'textDropdown';

  return (
    <div
      styleName={classnames(styling, {
        'list-dropdown': isOriginal,
        'list-text-dropdown': isTextDropdown
      })}
      tabIndex="0"
      aria-expanded={open}
      role="button"
      aria-label="section navigation"
      ref={toggleDropdown}
    >
      <span
        role="button"
        styleName={classnames({
          'dropdown-button': isOriginal,
          'text-dropdown-button': isTextDropdown
        })}
      >
        {title}
        {isOriginal && <i className="fl-triangle" />}
        {isTextDropdown && (
          <span
            styleName={classnames({
              'arrow-closed-menu': !open,
              'arrow-opened-menu': open
            })}
          >
            <i className="fl-navigate_next" />
          </span>
        )}
      </span>
      {open && (
        <nav styleName="dropdown-items" ref={dropdownListRef}>
          {isOriginal &&
            children.map(item => {
              if (item.button !== 'true') {
                return (
                  <Link to={item.url} key={item.name} styleName="navItem">
                    {item.name}
                  </Link>
                );
              } else {
                return null;
              }
            })}
          {isTextDropdown &&
            children.map(item => {
              return (
                <button
                  styleName="navItem"
                  style={{ color: 'black', textAlign: 'left' }}
                  onClick={() => {
                    item.handler();
                    setOpen(false);
                  }}
                  key={item.name}
                >
                  {item.name}
                </button>
              );
            })}
          {dropdownType === 'other' && children}
        </nav>
      )}
    </div>
  );
};

export default ListDropdown;
